module.exports = __webpack_public_path__ + "static/media/linen_blue.43a25d7d.svg";